import styled from 'styled-components';

export const StyledListingSearch = styled.div`
  max-width: 970px;
  display: grid;
  grid-template-columns: repeat(3, 260px) 120px;
  grid-template-rows: 78px;
  grid-gap: 0 20px;
  margin: 0 0 0 0;
`;

export const StyledChildDatePicker = styled.div`
  height: 70px;
  padding: 15px;
`;

export const SearchButtonWrapper = styled.div`
  button {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`;

export const SearchBarItemWrapper = styled.div<{ overFlow?: string }>`
  position: relative;
  height: 100%;
  overflow: ${({ overFlow }) => overFlow || 'hidden'};
  border-radius: 8px;
  & .react-tiny-popover-container {
    width: 100% !important;
    max-width: 542px !important;
  }
`;

export const ListingSearchButtonWrapper = styled.div`
  grid-column: 3;
  grid-row: 1 / 3;
  button {
    width: 100%;
    height: 100%;
  }
`;
